import script from "./BangKeChiTietNhapPrintTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./BangKeChiTietNhapPrintTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./BangKeChiTietNhapPrintTemplate.vue?vue&type=style&index=0&id=9308d0b6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9308d0b6"]])

export default __exports__